import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { AceTabContentComponent } from './Tab-Content/tabContent.component';

/** Structure to represent a single tab */

export interface ITabPage {
    /** (optional) A unique key for this tab.  Default: Use the label for the key */
    key?: string;

    /** The label for this tab */
    label: string;

    /** The content of this tab */
    content?: any;
}

/** Input for TabSet element */
export interface TabSetInput {
    /** The list of tabs to display */
    tabs?: ITabPage[];
    /** The list of tabs to display - comes from Blade input */
    tabActions?: ITabPage[];

    /** The key of the currently active tab */
    activeTab?: string;

    /** (Optional) Do not display the tabs, only the content.  Default: tab buttons with labels displayed above tab content */
    suppressTabDisplay?: boolean;

    /** (Optional) Stack tabs vertically.  Default: horizontal tabs */
    enableVerticalDisplay?: boolean;

    /** (optional) Whether this container should fill 100% height of it's parent.  Default: auto height */
    fillHeight?: boolean;

    /** render the output in a different target */
    contentTarget?: string;
}

@Component({
    selector: 'ws-ace-tab-set',
    templateUrl: './tabSet.component.html',
    styleUrls: ['./tabSet.component.scss'],
    standalone: false
})
export class AceTabSetComponent implements AfterContentInit {
    @Input() input: TabSetInput = {};
    @ContentChildren(AceTabContentComponent) tabs!: QueryList<AceTabContentComponent>;

    ngAfterContentInit(): void {
        if (!this.input?.tabs) {
            const tabs = this.tabs?.toArray();
            this.input.tabs = tabs.map(x => ({ label: x.heading }));
        }
        const activeTab = this._getTabContent(this.input.activeTab);
        activeTab.loaded = true;
        activeTab.active = true;
    }

    onTabClick(tab: ITabPage): void {
        this.input.activeTab = tab.key || tab.label;
        this.tabs.forEach(x => x.active = false);
        const activeTab  = this._getTabContent(this.input.activeTab);
        activeTab.active = true;
        activeTab.loaded = true;
    }

    private _getTabContent(tabName: string): AceTabContentComponent {
        const tabs = this.tabs?.toArray();
        return tabs.find(x => (x.heading === tabName)) || tabs[0];
    }
}
